import React, { createContext, useContext, useEffect, useState } from 'react';

const AuthContext = createContext(null);

export const ROLES = [
  'Administrador',
  'Técnico de Servicio',
  'Técnico Instalador',
  'Vendedor',
  'Mostrador'
];

// Usuarios iniciales — ACERO & CRISTAL MTY
const DEFAULT_USERS = [
  { id: 'u_admin', nombre: 'Administrador', usuario: 'ventas@aceroycristalmty.com', password: 'Demo123456789', rol: 'Administrador' },
  { id: 'u_nelson', nombre: 'Nelson', usuario: 'nelson', password: 'Acero2026', rol: 'Técnico de Servicio' },
  { id: 'u_leonel', nombre: 'Leonel', usuario: 'leonel', password: 'Acero2026', rol: 'Técnico de Servicio' },
  { id: 'u_dylangracia', nombre: 'Dylan David Gracia', usuario: 'dylangracia', password: 'Acero2026', rol: 'Técnico de Servicio' },
  { id: 'u_dylanlopez', nombre: 'Dylan Lopez', usuario: 'dylanlopez', password: 'Acero2026', rol: 'Técnico Instalador' },
  { id: 'u_haziel', nombre: 'Haziel', usuario: 'haziel', password: 'Acero2026', rol: 'Técnico Instalador' },
  { id: 'u_cristobal', nombre: 'Cristóbal', usuario: 'cristobal', password: 'Acero2026', rol: 'Técnico Instalador' },
  { id: 'u_lucas', nombre: 'Lucas', usuario: 'lucas', password: 'Acero2026', rol: 'Vendedor' },
  { id: 'u_michael', nombre: 'Michael', usuario: 'michael', password: 'Acero2026', rol: 'Vendedor' },
  { id: 'u_charlotte', nombre: 'Charlotte', usuario: 'charlotte', password: 'Acero2026', rol: 'Mostrador' },
  { id: 'u_olivia', nombre: 'Olivia', usuario: 'olivia', password: 'Acero2026', rol: 'Mostrador' }
];

// Páginas permitidas por rol
export function pagesForRole(rol) {
  if (rol === 'Administrador') return ['agenda', 'clientes', 'inventario', 'notas', 'usuarios', 'reportes', 'ajustes'];
  if (rol === 'Vendedor' || rol === 'Mostrador') return ['agenda', 'clientes', 'inventario', 'notas'];
  return ['agenda', 'clientes', 'inventario', 'notas'];
}

// Técnicos = usuarios que pueden ser asignados como "Técnico que atendió"
export function isTecnico(rol) {
  return rol === 'Técnico de Servicio' || rol === 'Técnico Instalador';
}

function load(key, fallback) {
  try {
    const v = localStorage.getItem(key);
    return v ? JSON.parse(v) : fallback;
  } catch (e) { return fallback; }
}

export function AuthProvider({ children }) {
  const [users, setUsers] = useState(() => load('dc_users', DEFAULT_USERS));
  const [user, setUser] = useState(() => load('dc_user', null));
  const [clinicName, setClinicName] = useState(() => localStorage.getItem('dc_clinicName') || 'ACERO & CRISTAL MTY');
  const [clinicLogo, setClinicLogo] = useState(() => localStorage.getItem('dc_clinicLogo') || '');

  useEffect(() => { localStorage.setItem('dc_users', JSON.stringify(users)); }, [users]);
  useEffect(() => {
    if (user) localStorage.setItem('dc_user', JSON.stringify(user));
    else localStorage.removeItem('dc_user');
  }, [user]);
  useEffect(() => { localStorage.setItem('dc_clinicName', clinicName); }, [clinicName]);
  useEffect(() => { localStorage.setItem('dc_clinicLogo', clinicLogo); }, [clinicLogo]);

  const login = (usuario, password) => {
    const u = users.find(
      x => x.usuario.toLowerCase().trim() === usuario.toLowerCase().trim() && x.password === password
    );
    if (u) { setUser(u); return { ok: true }; }
    return { ok: false, error: 'Usuario o contraseña incorrectos' };
  };

  const logout = () => setUser(null);

  const addUser = (data) => {
    const nuevo = { ...data, id: 'u_' + Date.now() };
    setUsers(prev => [...prev, nuevo]);
    return nuevo;
  };

  const updateUser = (id, data) => {
    setUsers(prev => prev.map(u => (u.id === id ? { ...u, ...data } : u)));
    if (user && user.id === id) setUser(prev => ({ ...prev, ...data }));
  };

  const removeUser = (id) => setUsers(prev => prev.filter(u => u.id !== id));

  const changePassword = (actual, nueva) => {
    if (!user) return { ok: false, error: 'Sin sesión' };
    const u = users.find(x => x.id === user.id);
    if (!u || u.password !== actual) return { ok: false, error: 'La contraseña actual no es correcta' };
    updateUser(user.id, { password: nueva });
    return { ok: true };
  };

  return (
    <AuthContext.Provider value={{
      user, users, login, logout,
      addUser, updateUser, removeUser, changePassword,
      clinicName, setClinicName, clinicLogo, setClinicLogo
    }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() { return useContext(AuthContext); }
